import styled from 'styled-components';

export const Text = styled.span`
  ${(props) =>
    props.disabled &&
    `
    cursor: not-allowed;
    opacity: 0.5;
  `}
`;
